import { TField } from "../components/forms/DynamicForm"
import { STATES } from "../utils/constant"

// Interfaces
export interface MyObject {
    src: string;
    priority: number;
    title: string;
}

export interface TransactionDetail {
    globalTransactionNumber: string,
    centreId: string,
    customerRefNo: string,
    status: string,
    transactionType: string,
    weightUOM: string,
    currency: string,
    remarks: string,
    inboundId: string,
    createdAt: string,
    updatedAt: string,
    secondaryTransactionLocation: string
}

export interface TranscationData {
    data: TransactionDetail | boolean
}

type InventoryImage = {
    src: string,
    title: string,
    priority: Number
}

export interface RowStatus {
    id: string | number,
    status: number | string,
    serialNumbers?: Array<number | string>,
    acknowledgedWeight?: number | string,
    acknowledgedQuantity?:number | string
}

export type TInventory = {
    id: number;
    name: string,
    skuId?: string,
    metalType: string,
    inventoryType: number,
    serialNumbers: string,
    unitWeight: number,
    currentWeight: number,
    currentFineWeight: number,
    quantity: number
    createdAt: string,
    updatedAt: string,
    shape?: string,
    purity?: number,
    images?: InventoryImage[],
    globalTransactionNumber?: string
}

export type InventoryData = TInventory & {
    dimensions?: string,
    transactionDetails?: TransactionDetail,
    isEditable?: boolean
    transferredWeight?: Number,
    transferredQuantity?: Number,
    requstQty?: Number,
    remarks?: string,
    silverFineWeight? : number,
    goldFineWeight?: number,
    selectedSerialNumbers?: number[],
    selectedRowIds?: number[],
    fineWeightChange?: number,
    metal?: string,
    totalNetWeightGm?: number, 
    totalFineWeightGm?: number
}


export type CreateRequestData ={
    skuId: any;
    id: number,
    productName: string,
    metalType:string,
    isEditable?: boolean
    reqQuantity:number,
    createdAt: string,
    updatedAt: string,

}
export interface SerialNumbers {
    data: InventoryData | boolean
}

export type IInventoryParams = {
    channelId: string
    metaltype?: string
    bifurcationMetalType?: String
    page?: number,
    pageSize?: number,
    filterModel?: any
}

export type IInventoryResponse = {
    channelId: string,
    subChannelId: string,
    data: InventoryData[],
    count?: number,
}

export type IGetBusinessUnitResponse = {
    label: string,
    value: string,
    plantPvc?: boolean
}

export interface SerialNumbersRow {
    id: string,
    skuId: string,
    serialNumber: any
}

export interface FormField {
  id: string
  fieldName: string;
  isVisible: boolean;
  line1: string;
  state: string;
  city: string;
  stateCode: string;
  pincode: string
  gstin: string;
  fieldType: 'text' | 'number' | 'select' | 'checkbox' | string; // extend if needed
  label: string;
  disabled?: boolean
  width?: string
  options?: []
  validation?: {},
}

export interface AddressCardProps {
  form: FormField[];
  heading: string;
}

export interface StockTransferData {
    inventoryLineItems: InventoryData[],
    selectedSerialNumber?: Number[],
    status?: String,
    shipper_id: String | undefined,
    destination_id: String,
    delivery_challan_no?: String,
    total_gold_fine_weight: Number,
    total_silver_fine_weight: Number,
    acknowledgement_remarks?: String,
    mts_delivery_challan_code?: String,
    gross_rate?: Number,
    invoice_grand_total?: Number,
    acknowledged_at?: String,
    created_by?: String | undefined,
    remarks: string
    awb_number?:string
    metal?: string,
    totalNetWeightGm?: number, 
    totalFineWeightGm?: number,
    logistic_agency_name?: String
    bifurcationMetalType?: String,
    isTransferOutbound?: boolean,
    meltingChargePerLot? : string,
    weight? : string
    refiningChargePerGm? : string,
    noOfLots? : string 
     
}

interface InventoryAdjRow {
    center_id: string,
    created_by: string | undefined,
    sku: string,
    remarks: string,
    inventory_type: number,
    adjustment_direction: number,
    adjustment_type: number,
    quantity_change: number
}
export interface InventoryAdjustment { 
    lineItem: InventoryData,
    selectedSerialNumber: Number
}

interface StoUpdateData {
    awb_number: string,
    stoId: string 
}

export interface IStoUpdate {
    params: StoUpdateData
}

export interface IStoCancel {
    stoId: string,
    centerId: string
}

type TCenter={
    center:string
}
export type TProductData = {
    id: string
    productName: string
    description: string
    metalType: string
    fineWeight: Number
    metalPurity: string
    shape: string
    dimensions: string
    category: string
    productType: string
    images: string[]
    isEditable?: boolean
    requstQty?: Number
    centerId: TCenter[]
}


export type TGetStoReqResponse = {
    id: number
    raisedBy: string
    requestorCenter: string
    requestedCenter: string
    remarks: string | null
    status: string
    createdAt: Date
    updatedAt: Date
}

export type TCreateStoReqResponse = {
    id: number
    line_item_id: number
    sku_id: string | null
    metal_type: string
    quantity: number
    weight: number
    purity: number
    fine_weight: number
    created_at: Date
    updated_at: Date
}
export type  TCreateStockReqParams = {
    businessUnit?: String,
    remarks?: String,
    lineItems?: any,
    id?:number
    rejectRequest?:boolean
}

export type STO_REQUESTS_FIELDS = {
    id: number
    raised_by: string
    requestor_center: string
    requested_center: string
    remarks: string
    created_at: Date
    updated_at: Date
}

export type STO_REQUEST_LINE_ITEMS_FIELDS = {
    line_item_id: number
    sto_requested_id: string
    sku_id: string | null
    metal_type: string
    reqQuantity: number
    weight: number
    purity: number
    fine_weight: string
    float: string
    remarks: string
    created_at: Date
    updated_at: Date
}

export type TStockReqDetail = {
    skuId: String,
    metalType: String,
    weight: Number,
    quantity: Number,
    fineWeight: Number,
    purity: Number,
    createdAt: Date
    updatedAt: Date
}
export interface IStockData {
    data: TStockReqDetail | boolean
}

export type TReqIncomoingInventory = {
    selectedSerialNumbers: any;
    id: number;
    name: string,
    skuId?: string,
    metalType: string,
    inventoryType: number,
    serialNumbers: string,
    unitWeight: number,
    currentWeight: number,
    currentFineWeight: number,
    fineWeight:Number,
    quantity: number
    reqQuantity: number
    shape?: string,
    purity?: number,
    images?: InventoryImage[],
    createdAt: string,
    updatedAt: string,
    dimensions?: string,
    transactionDetails?: TransactionDetail,
    isEditable?: boolean
    transferredWeight?: Number,
    transferredQuantity?: Number,
    remarks?: string,
    silverFineWeight? : Number,
    goldFineWeight?: Number,
    stoReqLineItemId: Number
}

export interface IStoId {
    stoId: string;
    url?: string;
    type?: string;
}

export const INV_INVENTORY_ADJUSTMENT_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: 'adjustmentNo',
        label: 'Adjustment No',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'transactionType',
        label: 'Transaction Type',
    },
    {
        id: 'reasonCode',
        label: 'Reason Code',
    },
    {
        id: 'bu',
        label: 'BU',
    },
    {
        id: 'location',
        label: 'Location',
    },
    {
        id: 'subInventory',
        label: 'Sub Inventory',
    },
    {
        id: 'locator',
        label: 'Locator',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'sourceBuerence',
        label: 'Document Reference',
    },
    {
        id: 'buReference',
        label: 'BU Reference',
    },
    {
        id: 'gtNumber',
        label:'GT Number',
    },
    {
        id: 'gtTransactionType',
        label: 'GT Transaction Type',
    },
]

export const INV_TRANSFER_ORDER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: 'transferNo',
        label: 'Transfer No',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'purposeOfTransfer',
        label: 'Purpose Of Transfer',
    },
    {
        id: 'sourceBusinessunit',
        label: 'Source Businessunit',
    },
    {
        id: 'sourceLocation',
        label: 'Source Location',
    },
    {
        id: 'targetBusinessunit',
        label: 'Target Businessunit',
    },
    {
        id: 'targetLocation',
        label: 'Target Location',
    },
    {
        id: 'transporterBU',
        label: 'Transporter BU',
    },
    {
        id: 'receiptDate',
        label: 'Receipt Date',
    },
    {
        id: 'deliveryType',
        label: 'Delivery Type',
    },
    {
        id: 'incoterm',
        label: 'Incoterm',
    },
    {
        id: 'buReference',
        label: 'BU Reference',
    },
    {
        id: 'transporterReference',
        label: 'Transporter Reference',
    },
    {
        id: 'receiptReference',
        label: 'Receipt Reference',
    },
    {
        id: 'gtNumber',
        label: 'GT Number',
    },
    {
        id: 'gtTransactionType',
        label: 'GT Transaction Type',
    },
]

export const INV_INVENTORY_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: 'itemNo',
        label: 'Item No',
    },
    {
        id: 'itemDescription',
        label: 'Item Description',
    },
    {
        id: 'metal',
        label: 'Metal',
    },
    {
        id: 'productFineWt',
        label: 'Product Fine Wt(Gm)',
    },
    {
        id: 'bu',
        label: 'BU',
    },
    {
        id: 'inventoryLocation',
        label: 'Inventory Location',
    },
    {
        id: 'subInventory',
        label: 'Sub Inventory',
    },
    {
        id: 'stockLocator',
        label: 'Stock Locator',
    },
    {
        id: 'qtyOnHand',
        label: 'Qty On Hand',
    },
    {
        id: 'qtyAvailableForSales',
        label: 'Qty Available For Sales',
    },
    {
        id: 'qtyAvailableForTransfer',
        label: 'Qty Available For Transfer',
    },
    {
        id: 'openOrderQty',
        label: 'Open Order Qty',
    },
    {
        id: 'onOrderQty',
        label: 'On Order Qty',
    },
    {
        id: 'qtyInTransitInbound',
        label: 'Qty In-Transit Inbound',
    },
    {
        id: 'qtyInTransitOutbound',
        label: 'Qty In-Transit Outbound',
    },
    {
        id: 'fineMetalBaseUnit',
        label: 'Fine Metal Base Unit',
    },
    {
        id: 'netMetalBaseUnit',
        label: 'Net Metal Base Unit',
    },
] 

export const INV_INVENTORY_SHOWCASE = [
    {
        id: "image",
        label: 'Image',
    },
    {
        id: "name",
        label: 'Name',
    },
    {
        id: "metalType",
        label: 'Metal Type',
    },
    {
        id: "inventoryType",
        label: 'Inventory Type',
    },
    {
        id: "skuId",
        label: 'SKU Id',
    },
    {   
        id: "quantity",
        label: 'Quantity',
    },
    {
        id: "currentWeight",
        label: 'Weight (gm)',
    },
    {
        id: "currentFineWeight",
        label: 'Current Fine Weight'
    },
    {
        id: "purity",
        label: 'Purity',
    },
    // {
    //     id: "availableStock",
    //     label: 'Available Stock',
    // },
    {
        id: "dimensions",
        label: 'Dimension',
    },
    {
        id: "shape",
        label: 'Shape',
    },
    {
        id: "transactionDetails",
        label: 'Transaction Details',
    },
    {
        id: 'globalTransactionNumber',
        label: 'GT Number'
    },
    {
        id: "serialNumbers",
        label: 'Serial Numbers',
    }
]
export const INV_STO_COLUMN = [
    {
        id: "image",
        label: 'Image',
    },
    {
        id: "name",
        label: 'Name',
    },
    {
        id: "metalType",
        label: 'Metal Type',
    },
    {
        id: "inventoryType",
        label: 'Inventory Type',
    },
    {
        id: "skuId",
        label: 'SKU Id',
    },
    {
        id: "weight",
        label: 'Weight (gm)',
    },
    {
        id: "transferredWeight",
        label: 'Transferred Weight* (gm)'
    },
    {
        id: "quantity",
        label: 'Quantity'
    },
    {
        id: "transferredQuantity",
        label: 'Transferred Quantity*'
    },
    {
        id: "serialNumbers",
        label: 'Serial Numbers*',
    },
    {
        id: "remarks",
        label: 'Remark'
    },
    {
        id: 'globalTransactionNumber',
        label: 'GT Number'
    }
]
export const INV_AJUSTMENT_COLUMN = [
    {
        id: "inventoryType",
        label: 'Inventory Type',
    },
    {
        id: "weight",
        label: 'Weight (gm)',
    },
    {   
        id: "quantity",
        label: 'Quantity',
    },
    {
        id: "serialNumbers",
        label: 'Serial Numbers',
    },
    {
        id: "remarks",
        label: 'Remark'
    }
]

export const INV_STO_TABLE = [
    {
        id: "stoId",
        label: "STO Id"
    },
    {
        id: "downloadInvoice",
        label: "Download Documents"
    },
    {
        id: "awbNumber",
        label: "AWB Number"
    },
    {
        id: "status",
        label: "Status"
    },
    {
        id: "shipperId",
        label: "Shipper"
    },
    {
        id: "destinationId",
        label:"Destination"
    },
    {
        id: "logisticAgencyName",
        label:"Transporter"
    },
    {
        id: "linkedTransactionType",
        label: 'Linked Transaction Type'
    },
    {
        id:"deliveryChallanNo",
        label:"Document No"
    },
    {
        id:"MTSDeliveryChallanCode",
        label:"MTS Delivery Challan Code" 
    },
    {
        id:"grossRate",
        label:"Gross Rate" 
    },
    {
        id:"invoiceGrandTotal",
        label:"Invoice Grand Total" 
    },
    {
        id:"totalGoldWeight",
        label:"Total Gold Weight"
    },
    {
        id:"totalSilverWeight",
        label:"Total Silver Weight"
    },
    {
        id:"totalGoldFineWeight",
        label:"Total Gold Fine Weight"
    },
    {
        id:"totalSilverFineWeight",
        label:"Total Silver Fine Weight "
    },
    {
        id:"isMTSTransfer",
        label:"MTS Transfer"
    },
    {
        id:"MTSTransferType",
        label:"MTS Transfer Type "
    },
    // {
    //     id:"isMTSUpdated",
    //     label:"isMTSUpdated"
    // },
    {
        id:"fullName",
        label:"Created By"
    },
    {
        id:"remarks",
        label:"Remarks" 
    },
    {
        id:"acknowledgementRemarks",
        label:"Acknowledgement Remarks" 
    },
    {
        id:"acknowledgedAt",
        label:"Acknowledged At" 
    },
    {
        id: "createdAt",
        label: "Created At"
    },
    {
        id: "updatedAt",
        label: "Updated At"
    },
    {
        id: "metalOutTime",
        label: "Metal out time"
    },
    {
        id: "metalOutUpdatedTime",
        label: "Metal out updated time"
    },
    {
        id:"lineItem",
        label:"Line Item Details"
    },
    {
        id:"acknowledge",
        label:"Acknowledge"
    },
    {
        id:"actions",
        label:"Actions"
    }
]

// INV LineItem modal info
export const INV_LINEITEM_MODAL = [
    {
        id:"imageURL",
        label:"Image"
    },
    {
        id:"name",
        label:"Name"
    },
    {
        id:"inventoryType",
        label:"Inventory Type"
    },
    {
        id:"skuId",
        label:"SKU Id"
    },
    // {
    //     id:"fineWeight",
    //     label:"Fine Weight"
    // },
    {
        id:"weight",
        label:"Total Weight"
    },
    {
        id:"quantity",
        label:"Quantity"
    },
    {
        id:"metalType",
        label:"Metal Type"
    },
    {
        id:"serialNumbers",
        label:"Serial Numbers"
    },
    {
        id:"transactionDetails",
        label:"Transaction Details"
    }
]

// for action button modal
export const INV_ACTION_MODAL = [
    {
        id:"imageURL",
        label:"Image"
    },
    {
        id:"name",
        label:"Name"
    },
    {
        id:"inventoryType",
        label:"Inventory Type"
    },
    {
        id:"skuId",
        label:"SKU Id"
    },
    {
        id:"weight",
        label:"Weight (gm)"
    },
    {
        id:"quantity",
        label:"Quantity"
    },
    {
        id:"metalType",
        label:"Metal Type"
    },
    {
        id:"statusLineItem",
        label:"Status Line Item"
    },
    {
        id:"acknowledgedQuantity",
        label:"Acknowledged Quantity"
    },
    {
        id:"acknowledgedWeight",
        label:"Acknowledged Weight"
    },
    {
        id:"acknowledgedSerialNumbers",
        label:"Acknowledged Serial Numbers"
    }
]

export const INV_SERIAL_NUMBER_MODAL = [
    {
        id:"image",
        label:"Image"
    },
    {
        id:"name",
        label:"Name"
    },
    {
        id:"id",
        label:"Product Id"
    },
    {
        id:"inventoryType",
        label:"Inventory Type"
    },
    {
        id:"skuId",
        label:"SKU Id"
    },
    {
        id:"fineWeight",
        label:"Unit Weight"
    },
    {
        id:"weight",
        label:"Total Weight"
    },
    {
        id:"quantity",
        label:"Quantity"
    },
    {
        id:"metalType",
        label:"Metal Type"
    },
    // {
    //     id:"serialNumbers",
    //     label:"Serial Numbers"
    // },
    // {
    //     id:"transactionDetails",
    //     label:"Transaction Details"
    // },
    {
        id:"acknowledgeSerialNumbers",
        label:"Acknowledge Serial Numbers"
    }
]

export const INV_SERIALNUMBER_MODAL = [
    {
        id:"skuId",
        label:"SKU Id"
    },
    {
        id:"serialNumbers",
        label:"Serial Number"
    },
]

// for screen 2  JUST AN EXAMPLE
export const INV_OUTGOING_INCOMING_TABLE = [
    {
        id: "requestorCentre",
        label: "Requestor Centre"
    },
    {
        id: "requestedCentre",
        label: "Requested Centre"
    },
    {
        id: " status",
        label: " Status"
    },
    {
        id: "createdAt",
        label: "Created At"
    },
    {
        id: "updatedAt",
        label: "Updated At"
    },
    {
        id: "requestedSkuDetail",
        label:"Requested SKU Detail"
    }
]

// Fields
export const SEARCH_INVENTORY_CONFIG: TField<any>[] =[
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label:'Date From',
        fullWidth:false,
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label:'Date To',
        fullWidth:false,
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'transactionType',
        isVisible: true,
        fieldType: 'text',
        label:'Transaction Type',
        fullWidth:false,        
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'transactionLocation',
        isVisible: true,
        fieldType: 'text',
        label:'Transaction Location',
        fullWidth:false,
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'customer',
        isVisible: true,
        fieldType: 'autocomplete',
        options:[{value:1, label:'ABC'}],
        label:'Customer',
        fullWidth:false,
        width:'calc(20% - 20px)'
    },
]
export const INV_ADJUSTMENT_SCONFIG: TField<any>[] =[
    {
        fieldName: 'adjustment',
        isVisible: true,
        fieldType: 'text',
        label:'Adjustment',
        fullWidth:false,
        width:'calc(15% - 20px)'
    },
    {
        fieldName: 'documentRef',
        isVisible: true,
        fieldType: 'text',
        label:'Document Ref',
        fullWidth:false,
        width:'calc(15% - 20px)'
    },
    {
        fieldName: 'buRef',
        isVisible: true,
        fieldType: 'text',
        label:'BU Ref',
        fullWidth:false,
        width:'calc(15% - 20px)'
    },
    {
        fieldName: 'selectBU',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Select BU',
        fullWidth:false,
        options:[{value:'abc', label:'ABC'},{value:'xyz', label:'XYZ'}],
        width:'calc(15% - 20px)'
    },
    {
        fieldName: 'selectLocation',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Select Location',
        fullWidth:false,
        options:STATES,
        width:'calc(15% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Status',
        fullWidth:false,
        options:[{value:'new', label:'New'},{value:'readyForCompletion', label:'Ready for completion'},{value:'completed', label:'Completed'},{value:'cancelled', label:'Cancelled'},{value:'readyForApproval', label:'Ready For Approval'},{value:'approved', label:'Approved'},{value:'deliveredToLogistics', label:'Delivered To Logistics'},{value:'received', label:'Received'}],
        width:'calc(15% - 20px)'
    },
]
export const INV_TRANSFER_ORDER_SCONFIG: TField<any>[] =[
    {
        fieldName: 'transfer',
        isVisible: true,
        fieldType: 'text',
        label:'Transfer',
        fullWidth:false,
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'sourceBU',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Source BU',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'sourceLocation',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Source Location',
        fullWidth:false,
        options: STATES,
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'targetBU',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Target BU',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'targetLocation',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Target Location',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
]
export const INV_INVENTORY_SCONFIG: TField<any>[] =[
    {
        fieldName: 'bu',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'BU',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'inventoryLocation',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Inventory Location',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'product',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Product',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'quantity',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Quantity',
        fullWidth:false,
        options:[{value:'', label:''}],
        width:'calc(20% - 20px)'
    },
    {
        fieldName: 'groupBy',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Group By',
        fullWidth:false,
        options:[{value:'inventoryLocation',label:'Inventory Location'},{value:'subInventoryLocation',label:'Sub Inventory Location'}],
        width:'calc(20% - 20px)'
    },
]
export const INV_TRANSFER_ORDER_CONFIG: TField<any>[] =[
    {
        fieldName: 'sourceBU',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Source BU',
        fullWidth:false,
        options:[{value:'', label:''}],
    },
    {
        fieldName: 'sourceLocation',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Source Location',
        fullWidth:false,
        options:[{value:'', label:''}],
    },
    {
        fieldName: 'targetBU',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Target BU',
        fullWidth:false,
        options:[{value:'', label:''}],
    },
    {
        fieldName: 'targetLocation',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Target Location',
        fullWidth:false,
        options:[{value:'', label:''}],
    },
    {
        fieldName: 'deliveryType',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Delivery Type',
        fullWidth:false,
        options:[{value:'', label:''}],
    },
    {
        fieldName: 'incoTerm',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'IncoTerm',
        fullWidth:false,
        options:[{value:'ddlDoorDelivery', label:'DDL Door Delivery'},{value:'pickUp', label:'Pick-Up'},{value:'nonLocalPickup', label:'Non Local Pick-up'}],
    },
    {
        fieldName: 'transporterBU',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Transporter BU',
        fullWidth:false,
        options:[{value:'', label:''}],
    },
    {
        fieldName: 'purposeOfTransfer',
        isVisible: true,
        fieldType: 'autocomplete',
        label:'Purpose Of Transfer',
        fullWidth:false,
        options:[{value:'minted', label:'Minted'},{value:'masterAlloy', label:'Master Alloy'},{value:'scrap', label:'Scrap'},{value:'bullion', label:'Bullion'}],
    },
    {
        fieldName: 'transorterReference',
        isVisible: true,
        fieldType: 'text',
        label:'Transorter Reference',
        fullWidth:false,
    },
    {
        fieldName: 'buReference',
        isVisible: true,
        fieldType: 'text',
        label:'BU Reference',
        fullWidth:false,
    },
  
]

export const transcationFields: any = {
    globalTransactionNumber: 'Global Transaction Number',
    status: 'Status',
    transactionType: 'Transaction Type',
    weightUOM: 'Weight UOM',
    currency: 'Currency',
    remarks: 'Remarks',
    centreId: 'Center ID',
    secondaryTransactionLocation: 'Secondary Transaction Location',
    customerRefNo: 'Customer Ref No',
    inboundId: 'Inbound ID',
    createdAt: 'Created At',
    updatedAt: 'Updated At'
}

export const logisticOptions = [
    {label:'Sequel', value: 'Sequel'},
    {label:'BVC Logistics', value: 'BVC Logistics'},
    {label:'Brinks India Pvt Ltd', value: 'Brinks India Pvt Ltd'},
    {label:'CMS Info system', value: 'CMS Info system'},
    {label:'Other', value: 'Other'},
]

export const INV_RGP_COLUMN = [
    {
        id: "image",
        label: 'Image',
    },
    {
        id: "name",
        label: 'Name',
    },
    {
        id: "metalType",
        label: 'Metal Type',
    },
    {
        id: "inventoryType",
        label: 'Inventory Type',
    },
    {
        id: "skuId",
        label: 'SKU Id',
    },
    {
        id: "weight",
        label: 'Weight (gm)',
    },
    {
        id: "transferredWeight",
        label: 'Transferred Weight* (gm)'
    },
    {
        id: "quantity",
        label: 'Quantity'
    },
    {
        id: "transferredQuantity",
        label: 'Transferred Quantity*'
    },
    {
        id: "serialNumbers",
        label: 'Serial Numbers*',
    },
]

export const RGP_TABLE = [
    {
        id: "rgpId",
        label: "RGP Id"
    },
    {
        id: "downloadInvoice",
        label: "Download Documents"
    },
    {
        id: "status",
        label: "Status"
    },
    {
        id: "customerName",
        label:"Customer name"
    },
    {
        id: "billingAddress",
        label: "Billing address"
    },
    {
        id:"deliveryChallanNo",
        label:"RGP No"
    },
    {
        id:"grossRate",
        label:"Gross Rate" 
    },
    {
        id:"invoiceGrandTotal",
        label:"Invoice Grand Total" 
    },
    {
        id:"totalGoldWeight",
        label:"Total Gold Weight"
    },
    {
        id:"totalSilverWeight",
        label:"Total Silver Weight"
    },
    {
        id:"totalGoldFineWeight",
        label:"Total Gold Fine Weight"
    },
    {
        id:"totalSilverFineWeight",
        label:"Total Silver Fine Weight "
    },
    {
        id:"fullName",
        label:"Created By"
    },
    {
        id:"remarks",
        label:"Remarks" 
    },
    {
        id:"acknowledgementRemarks",
        label:"Acknowledgement Remarks" 
    },
    {
        id:"acknowledgedAt",
        label:"Acknowledged At" 
    },
    {
        id: "createdAt",
        label: "Created At"
    },
    {
        id: "updatedAt",
        label: "Updated At"
    },
    {
        id:"lineItem",
        label:"Line Item Details"
    },
    {
        id:"actions",
        label:"Actions"
    }
]

export const BILLING_ADDRESS_DETAILS_FORM: TField<FormField>[] = [
    {
        fieldName: 'line1',
        isVisible: true,
        fieldType: 'text',
        label: 'Address line 1',
        width: 'calc(50% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'city',
        isVisible: true,
        fieldType: 'text',
        label: 'city',
        width: 'calc(50% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'state',
        isVisible: true,
        fieldType: 'text',
        label: 'State',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'stateCode',
        isVisible: true,
        fieldType: 'text',
        label: 'State Code',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'pincode',
        isVisible: true,
        fieldType: 'number',
        label: 'Pin code',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'gstin',
        isVisible: true,
        fieldType: 'text',
        label: 'GSTIN/Unique ID',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
]

export const SHIPPING_ADDRESS_DETAILS_FORM: TField<FormField>[] = [
    {
        fieldName: 'line1',
        isVisible: true,
        fieldType: 'text',
        label: 'Address line 1',
        width: 'calc(50% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'city',
        isVisible: true,
        fieldType: 'text',
        label: 'city',
        width: 'calc(50% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'state',
        isVisible: true,
        fieldType: 'text',
        label: 'State',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'stateCode',
        isVisible: true,
        fieldType: 'text',
        label: 'State Code',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'pincode',
        isVisible: true,
        fieldType: 'number',
        label: 'Pin code',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'gstin',
        isVisible: true,
        fieldType: 'text',
        label: 'GSTIN/Unique ID',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
]

export const RGP_LINEITEM_MODAL = [
    {
        id:"imageURL",
        label:"Image"
    },
    {
        id:"name",
        label:"Name"
    },
    {
        id:"inventoryType",
        label:"Inventory Type"
    },
    {
        id:"skuId",
        label:"SKU Id"
    },
    {
        id:"weight",
        label:"Total Weight"
    },
    {
        id:"quantity",
        label:"Quantity"
    },
    {
        id:"metalType",
        label:"Metal Type"
    },
    {
        id:"serialNumbers",
        label:"Serial Numbers"
    }
]

export const RGP_ACK_LINEITEM_MODAL = [
    {
        id:"name",
        label:"Name"
    },
    {
        id:"skuId",
        label:"SKU Id"
    },
    {
        id:"weight",
        label:"Total Weight"
    },
    {
        id:"quantity",
        label:"Quantity"
    },
    {
        id:"metalType",
        label:"Metal Type"
    },
    {
        id:"serialNumbers",
        label:"Serial Numbers"
    }
]

export interface IRGPId {
    rgpId: string;
    url?: string;
    type?: string;
}

export interface IRGPCancel {
    rgpId: string,
    centerId: string
}

export interface IRGPUpdate {
    rgpId: string
    acknowledgeRemark: string 
    customerInvoiceNo: string
}

export interface IRGPSearch {
   mobileNumber: string
}

export interface IIRNParams {
   stoId?: string
   GTNumber?: string
   type: string
   redeemOrderId?: string
}